export function buildExportData(prices, selectedProduct) {
    const titleRow = ['LOADING FILE ECAT']
    const headerRow = [
        'SAP KMAT',
        'SAP Varcond',
        'SAP reference',
        'Quantity',
        'eCAT naming (rules)',
        'Size',
        'Options Nb',
        'Type',
        'Price',
    ]

    const dataRows = []
    prices.forEach((price) => {
        const isBaseUnit = !price.optionId
        dataRows.push([
            price.kmat || null,
            price.varcond || null,
            price.reference || null,
            price.quantity || null,
            selectedProduct.name || null,
            price.size || null,
            isBaseUnit ? '-' : price.option?.number || null,
            isBaseUnit ? 'Base unit' : 'Option',
            price.price ?? null,
        ])
    })

    return { titleRow, headerRow, dataRows }
}
